import { render, staticRenderFns } from "./room_background.vue?vue&type=template&id=43684b67&scoped=true"
import script from "./room_background.vue?vue&type=script&lang=js"
export * from "./room_background.vue?vue&type=script&lang=js"
import style0 from "./room_background.vue?vue&type=style&index=0&id=43684b67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43684b67",
  null
  
)

export default component.exports